import React, { useState } from "react";
import axios from "axios";
import { API_IP } from "../env";
import jwtDecode from "jwt-decode";

// Import react-bootstrap components
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Alert,
} from "react-bootstrap";

function LoginScreen({ setIsLogin }) {
  // Use state for controlled components
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage(null); // Clear old errors

    try {
      // Use state variables for the request
      const { data } = await axios.post(`${API_IP}/api/login`, {
        username: username,
        password: password,
      });

      if (data.isAdmin) {
        localStorage.setItem("@uphealth_login_token", data.token);
        setIsLogin(true);
      } else {
        // Handle successful login but no admin rights
        setErrorMessage("You do not have permission to access this page.");
      }
    } catch (err) {
      // Handle 401 (Wrong user/pass) or network errors
      setErrorMessage("Invalid username or password. Please try again.");
      console.log(err);
    }
    setLoading(false);
  };

  return (
    // Center the login card on the page
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <Row className="justify-content-md-center w-100">
        {/* This column sets the card's width */}
        <Col md={8} lg={7}>
          <Card className="shadow-lg">
            <Card.Body className="p-4 p-md-5">
              {/* This Row creates the 2-column layout *inside* the card */}
              <Row className="align-items-center">
                {/* --- MODIFICATION: Column 1: Logo (41.6% width) --- */}
                <Col
                  md={5}
                  className="d-flex flex-column align-items-center justify-content-center mb-4 mb-md-0"
                >
                  <img
                    src={require("../assets/icon-uphealth.png")}
                    alt="UpHealth Logo"
                    style={{ width: "150px" }}
                  />
                </Col>

                {/* --- MODIFICATION: Column 2: Form (58.3% width) --- */}
                <Col md={7}>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Username or Email</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter username"
                        name="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        disabled={loading}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="Password"
                        name="pass"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        disabled={loading}
                      />
                    </Form.Group>

                    {/* Show error message if it exists */}
                    {errorMessage && (
                      <Alert variant="danger" className="py-2">
                        {errorMessage}
                      </Alert>
                    )}

                    <div className="d-grid">
                      <Button
                        variant="primary"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          "Login"
                        )}
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default LoginScreen;
